export default __webpack_public_path__ + "static/media/mail.a202522f.svg";